import api from "./axiosInstance";

// Get all user types (roles)
export const getUserTypes = async () => {
  const response = await api.get(
    "api/v1/account/user-types/"
  );
  return response.data;
};

// Create user type (already shared by backend)
export const createUserType = async (payload) => {
  const response = await api.post(
    "api/v1/account/user-types/",
    payload
  );
  return response.data;
};


export const updateUserType = async (userId, payload) => {
  const response = await api.patch(
    `api/v1/account/user-types/${userId}/`,
    payload
  );
  return response.data;
};


export const deleteUserType = async (userId) => {
  await api.delete(`api/v1/account/user-types/${userId}/`);
};